import * as signalR from '@microsoft/signalr';
import global from '../../global';

var connection;
async function tryStart() {
    connection = new signalR.HubConnectionBuilder().withUrl(global.socketBaseUrl).build();

    await connection.start().then(function () {
    }).catch(function (err) {
        console.log('start err', err);
        setTimeout(() => start(), 5000);
    });
}
async function start() {
    try {
        if (connection.connection.connectionState == 2) {
            await connection.start();
        }
    } catch (err) {
        setTimeout(() => start(), 5000);
    }
}

async function tryOn(method, callback) {
    await connection.off(method);
    await connection.on(method, r => {
        console.log(`on ${method} result:`, r);
        callback(r)
    })
}

async function tryStop() {
    await connection.stop().then(() => {
        connection = undefined;
    });
}

//将创建的signal赋值给Vue实例
export default {
    install: function (Vue) {
        Vue.prototype.signalr = {
            start: tryStart,
            on: tryOn,
            stop: tryStop
        }
    }
}